<template>
  <div class="aboutPark">
    <img src="@/assets/aboutPark3.png" class="pao pao1">
    <div class="pao pao2 wow slideInLeftSelf"></div>
    <div class="pao pao3 wow slideInRightSelf"></div>
    <div class="pao pao4    wow slideInLeftSelf"></div>
    <myMenu :type="2" @zoomChange="initWow"></myMenu>
    <div class="traffic_content">
      <div class="linear_word">TRAFFIC</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">交通指南</div>
      </div>
      <div class="main wow fadeIn">
        <img class="traffic_bg" src="@/assets/traffic_bg.png" alt="" srcset="">
        <!-- <div id="l-map" class="map_block"></div> -->
        <div class="map_address">
          <i class="map_address_icon"></i>
          <div class="map_address_name"><span>宁波熊出没欢乐港湾地址：</span>浙江省宁波市前湾新区天宝路189号</div>
        </div>
        <div class="traffic_way">
          <div class="way_item" :class="item.class" v-for="(item,index) in traffic_way" :key="index">
            <div class="traffic_icon"></div>
            <div class="traffic_block">
              <p class="traffic_name">{{item.type}}</p>
              <p v-if="item.dec" class="traffic_dec">{{item.dec}}</p>
              <template v-if="item.way">
                <div class="way_list" v-for="(eve,j) in item.way" :key="j">
                  <div class="way_list_name">{{eve.name}}</div>
                  <div class="way_list_dec" v-html="eve.wayDec"></div>
                </div>
              </template>
            </div>
          </div>
          <!-- <div class="way_item traffic_icon_4">
            <div class="traffic_icon"></div>
            <div class="traffic_block">
              <p class="traffic_name">交通指引图</p>
            </div>
          </div> -->
          <!-- <img class="traffic_bg" src="@/assets/traffic_bg.png" alt="" srcset=""> -->
        </div>
      </div>
    </div>
    <myBottom></myBottom>
  </div>
</template>

<script>
import myMenu from '@/components/myMenu.vue'
import myBottom from '@/components/myBottom.vue'

import "wowjs/css/libs/animate.css";
import "@/assets/css/wowExtra.css";
import { WOW } from 'wowjs'
// import P from '@/tools/project';
export default {
  components: { myMenu, myBottom, },
  data() {
    return {
      traffic_way: [
        {
          class: 'traffic_icon_1',
          type: '高铁、动车指引',
          dec: '乘坐高铁、动车抵达【余姚北站】后，可选择出站口附近的公交【余姚北站】搭乘公交。'
        },
        {
          class: 'traffic_icon_2',
          type: '公交线路',
          way: [
            {
              name: '',
              wayDec: '107路：前湾新区公交总站—杭州湾湿地公园站'
            },
            {
              name: '',
              wayDec: '107路（夜间）：前湾新区公交总站—方特站'
            },
            {
              name: '',
              wayDec: '228路：慈溪南站—方特站'
            },
            {
              name: '',
              wayDec: '255路：慈溪西站—方特站'
            },
            {
              name: '',
              wayDec: '游9路（299路）：余姚北站长途汽车站—方特站—创新创业大厦'
            },
          ]
        },
        {
          class: 'traffic_icon_3',
          type: '自驾路线',
          way: [
            {
              name: 'A.上海',
              wayDec: '沪昆高速→沈海高速→宁波杭州湾新区西出口→滨海二路→天宝路'
            },
            {
              name: 'B.嘉兴、苏州、常熟',
              wayDec: '常台高速→乍嘉苏高速→沈海高速→宁波杭州湾新区西出口→滨海二路→天宝路'
            },
            {
              name: ' C.宁波、舟山',
              wayDec: '甬舟高速→宁波绕城高速→沈海高速→宁波杭州杭州湾西出口→滨海二路→天宝路'
            },
            {
              name: 'D.杭州',
              wayDec: '沪昆高速→乍嘉苏高速→沈海高速→宁波杭州湾新区西出口→滨海二路→天宝路'
            },
            {
              name: 'E.绍兴、上虞',
              wayDec: '杭甬高速→牟山出口→姚北大道→芦庵线滨海二路→天宝路'
            },
            {
              name: 'F.台州、嵊州',
              wayDec: '沈海高速→常台高速→杭甬高速→牟山出口姚北大道→芦庵线→滨海二路→天宝路'
            },
          ]
        },
      ]
    }
  },
  mounted() {
    // this.setTraffic();
  },
  methods: {
    initWow(zoom) {
      var top = $('.traffic_content').offset().top;
      var offset = zoom >= 1 ? 200 * zoom : (200 * zoom - (top - top * zoom));
      var wow = new WOW(
        {
          animateClass: 'animated',
          offset,
          callback: box => {
            $(box).removeClass('wow');
          }
        }
      );
      wow.init();
    },
    BD09II2WGS84(bdLon, bdLat) {
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      //百度坐标转成火星坐标
      let mars_point = { lat: 0, lon: 0, };
      let x = bdLon - 0.0065;
      let y = bdLat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      mars_point.lat = z * Math.sin(theta);
      mars_point.lon = z * Math.cos(theta);

      //把火星坐标GCJ02转地球坐标系WGS84
      let gcjLat = mars_point.lat;
      let gcjLon = mars_point.lon;
      let d = this.delta(gcjLat, gcjLon)
      return {
        'lat': (gcjLat - d.lat),
        'lon': (gcjLon - d.lon)
      }
    },
    delta(lat, lon) {
      let PI = 3.14159265358979324;
      let a = 6378245.0
      let ee = 0.00669342162296594323
      let dLat = this.transformLat(lon - 105.0, lat - 35.0)
      let dLon = this.transformLon(lon - 105.0, lat - 35.0)
      let radLat = lat / 180.0 * PI
      let magic = Math.sin(radLat)
      magic = 1 - ee * magic * magic
      let sqrtMagic = Math.sqrt(magic)
      dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * PI)
      dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * PI)
      return {
        'lat': dLat,
        'lon': dLon
      }
    },
    transformLat(x, y) {
      let PI = 3.14159265358979324;
      let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
      ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0
      ret += (20.0 * Math.sin(y * PI) + 40.0 * Math.sin(y / 3.0 * PI)) * 2.0 / 3.0
      ret += (160.0 * Math.sin(y / 12.0 * PI) + 320 * Math.sin(y * PI / 30.0)) * 2.0 / 3.0
      return ret
    },
    transformLon(x, y) {
      let PI = 3.14159265358979324;
      let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
      ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0
      ret += (20.0 * Math.sin(x * PI) + 40.0 * Math.sin(x / 3.0 * PI)) * 2.0 / 3.0
      ret += (150.0 * Math.sin(x / 12.0 * PI) + 300.0 * Math.sin(x / 30.0 * PI)) * 2.0 / 3.0
      return ret
    },
    setTraffic() {
      //初始化地图对象
      var map = new T.Map('l-map', {
        projection: "EPSG:4326",
      });
      var obj = this.BD09II2WGS84(121.200852, 28.868702);
      var linlat = new T.LngLat(obj.lon, obj.lat);
      map.centerAndZoom(linlat, 15);
      //创建标注对象
      var marker = new T.Marker(linlat);
      map.addOverLay(marker);
    },
  },
}
</script>

<style lang="scss" scoped>
.aboutPark {
  .traffic_content {
    width: 1320px;
    margin: 110px auto 100px;
    position: relative;
    .main {
      border-radius: 20px;
      background-color: rgb(255, 255, 255);
      box-shadow: 0px 8px 54px 0px rgba(111, 159, 227, 0.3);
      padding: 100px 124px;
      margin-top: 60px;
      position: relative;
      padding-bottom: 0;
      .map_block {
        height: 575px;
        box-shadow: 0px 10px 20px 0px rgba(111, 159, 227, 0.38);
        border-radius: 20px;
      }
      .map_address {
        height: 141px;
        background: #ffffff;
        box-shadow: 0px 3px 24px 0px rgba(111, 159, 227, 0.3);
        border-radius: 10px;
        margin-top: 70px;
        display: flex;
        align-items: center;
        justify-content: left;
        font-size: 26px;
        margin-bottom: 83px;
        padding-left: 48px;
        .map_address_icon {
          width: 39px;
          height: 54px;
          background: url('../assets/map_address_icon.png') no-repeat;
          background-size: contain;
          margin-right: 33px;
          position: relative;
          &::after {
            content: '';
            width: 1px;
            height: 106px;
            background: #ed6660;
            display: inline-block;
            position: absolute;
            right: -33px;
            top: 0;
            bottom: 0;
            margin: auto;
          }
        }
        .map_address_name {
          margin-left: 33px;
          span {
            color: #ed6660;
          }
        }
      }
      .way_item {
        display: flex;
      }
      .traffic_way {
        display: flex;
        flex-direction: column;
        .traffic_icon {
          width: 80px;
          height: 80px;
          flex-shrink: 0;
          margin-right: 32px;
          background-size: contain;
          background-repeat: no-repeat;
        }
        .traffic_icon_1 {
          .traffic_icon {
            background-image: url('../assets/traffic_icon_1.png');
          }
          .traffic_name {
            color: #5195c7;
          }
        }
        .traffic_icon_2 {
          .traffic_icon {
            background-image: url('../assets/traffic_icon_2.png');
          }
          .traffic_name {
            color: #cb6262;
          }
        }
        .traffic_icon_3 {
          .traffic_icon {
            background-image: url('../assets/traffic_icon_3.png');
          }
          .traffic_name {
            color: #dd6d14;
          }
        }
        .traffic_icon_4 {
          .traffic_icon {
            background-image: url('../assets/traffic_icon_4.png');
          }
        }
        .traffic_block {
          margin-bottom: 69px;
          .traffic_name {
            font-size: 24px;
            margin-top: 5px;
          }
          .traffic_dec {
            font-size: 24px;
            margin-top: 20px;
          }
          .way_list_name {
            color: #dd6d14;
          }
          .way_list_dec {
            line-height: 40px;
            margin-bottom: 15px;
          }
          .way_list {
            font-size: 20px;
            margin-top: 10px;
          }
        }
      }
      .traffic_bg {
        border-radius: 20px;
        box-shadow: 0px 3px 24px 0px rgba(111, 159, 227, 0.3);
      }
    }
  }
  .pao1 {
    left: 0;
    top: 998px;
    width: 2638px;
  }
  .pao2 {
    border-radius: 50%;
    background-image: -moz-linear-gradient(
      33deg,
      rgb(255, 163, 122) 0%,
      rgb(254, 233, 168) 78%,
      rgb(254, 233, 168) 79%
    );
    background-image: -webkit-linear-gradient(
      33deg,
      rgb(255, 163, 122) 0%,
      rgb(254, 233, 168) 78%,
      rgb(254, 233, 168) 79%
    );
    background-image: -ms-linear-gradient(
      33deg,
      rgb(255, 163, 122) 0%,
      rgb(254, 233, 168) 78%,
      rgb(254, 233, 168) 79%
    );
    background-image: linear-gradient(
      33deg,
      rgb(255, 163, 122) 0%,
      rgb(254, 233, 168) 78%,
      rgb(254, 233, 168) 79%
    );
    opacity: 0.6;
    position: absolute;
    left: -42px;
    top: 991px;
    width: 239px;
    height: 239px;
  }
  .pao3 {
    border-radius: 50%;
    background-image: -moz-linear-gradient(
      -30deg,
      rgb(149, 219, 255) 0%,
      rgb(34, 107, 255) 81%
    );
    background-image: -webkit-linear-gradient(
      -30deg,
      rgb(149, 219, 255) 0%,
      rgb(34, 107, 255) 81%
    );
    background-image: -ms-linear-gradient(
      -30deg,
      rgb(149, 219, 255) 0%,
      rgb(34, 107, 255) 81%
    );
    background-image: linear-gradient(
      -30deg,
      rgb(149, 219, 255) 0%,
      rgb(34, 107, 255) 81%
    );
    opacity: 0.6;
    position: absolute;
    left: 1832px;
    top: 1503px;
    width: 303px;
    height: 303px;
  }
  .pao4 {
    background-image: -moz-linear-gradient(
      110deg,
      rgb(184, 242, 211) 13%,
      rgb(254, 253, 168) 100%
    );
    background-image: -webkit-linear-gradient(
      110deg,
      rgb(184, 242, 211) 13%,
      rgb(254, 253, 168) 100%
    );
    background-image: -ms-linear-gradient(
      110deg,
      rgb(184, 242, 211) 13%,
      rgb(254, 253, 168) 100%
    );
    background-image: linear-gradient(
      110deg,
      rgb(184, 242, 211) 13%,
      rgb(254, 253, 168) 100%
    );
    position: absolute;
    left: -138px;
    top: 2572px;
    width: 216px;
    height: 216px;
    border-radius: 50%;
  }
}
</style>